import { JSX } from 'preact/compat'
import { useState, useEffect, useRef, useCallback } from 'preact/hooks'
import Handler from './Handler'

type Props = {
  isOpen: boolean
  children: JSX.Element
  handlerImage: string
}

const Floater = (props: Props) => {
  const [isOpen, setOpen] = useState<boolean>(props.isOpen)

  const boxNode = useRef<HTMLDivElement>(null)
  const handlerNode = useRef<HTMLDivElement>(null)

  const toggleOpen = useCallback(() => {
    setOpen(prev => !prev)
  }, [])

  useEffect(() => {
    if (!boxNode.current) return

    if (isOpen) {
      boxNode.current.style.opacity = '1'
      boxNode.current.style.right = '30px'
    } else {
      boxNode.current.style.opacity = '0'
      setTimeout(() => {
        if (boxNode.current) {
          boxNode.current.style.right = '-99999px'
        }
      }, 150)
    }
  }, [isOpen])

  return (
    <div className="wf_reset wf_container wf_floater_wrapper">
      <div ref={boxNode} className="wf_reset wf_box wf_floater_box">
        {props.children}
      </div>
      <div ref={handlerNode} className="wf_reset wf_floater_handler">
        <Handler isOpen={isOpen} onClick={toggleOpen} imageUrl={props.handlerImage} />
      </div>
    </div>
  )
}

export default Floater
